/** Product mark: favicon, PWA, header (served from `public/`) */
export const APP_LOGO_PNG = '/smlouvy_z_katastru.png';
